var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 3H7C5.3 3 4 4.3 4 6V6.8C4 7.6 3.9 8.3 3.6 9.1C3.3 10.2 2.2 11 1 11V13C2.2 13 3.3 13.8 3.6 14.9C3.9 15.6 4 16.4 4 17.2V18C4 19.7 5.3 21 7 21H17C18.7 21 20 19.7 20 18V17.2C20 16.4 20.1 15.7 20.4 14.9C20.8 13.8 21.8 13 23 13V11C21.8 11 20.7 10.2 20.4 9.1C20.1 8.4 20 7.6 20 6.8V6C20 4.3 18.7 3 17 3Z",
    stroke: "#9096AD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7998 11.9998H12.6998C13.8998 11.9998 14.7998 12.8998 14.7998 14.0998C14.7998 15.2998 13.8998 16.1998 12.6998 16.1998H9.7998V7.7998H12.6998C13.8998 7.7998 14.7998 8.6998 14.7998 9.8998C14.7998 11.0998 13.8998 11.9998 12.6998 11.9998H9.7998Z",
    stroke: "#9096AD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.abfa24471d53b2a62a2d7a02faead377.svg";
export { ForwardRef as ReactComponent };